<template>
    <div class="button"
         :class="buttonList.colorClass"
         @click="goRoute"
    >
        {{buttonList.msg}}
    </div>
</template>

<script>
    export default {
        name: "Button",
        props: {
            buttonList: Object,
        },
        data() {
            return {}
        },
        methods: {
            goRoute() {
                if (this.buttonList.type === "value") {
                    this.$router.push({
                        path: this.buttonList.route,
                        query: {
                            ans_id: this.buttonList.ans_id,
                            ques_id: this.buttonList.ques_id,
                            ans_num: this.buttonList.ans_num,
                            crs_name: this.buttonList.crs_name,
                            name: this.buttonList.name,
                        }
                    });
                } else if (this.buttonList.type === "route") {
                    this.$router.push({path: this.buttonList.route})
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .button {
        width: 100px;
        height: 40px;
        margin-left: 10px;
        line-height: 40px;
        font-size: 14px;
        text-align: center;
        border-radius: 4px;
        cursor: pointer;
        color: #fff;
        background-color: red;
        margin-right: 6px;
    }

    .blue_color {
        background-color: #3D89FB;
    }

    .red_color {
        background-color: #F56C6C;
    }

    .grey_color {
        background-color: #999;
    }
</style>
